export interface AutomaticReadingResultData {
  liabilityAutomaticReadingId: string,
  title: string,
  amountToPay: number,
  paymentDue: Date,
  biller: string,
  billerId: string,
  bban: string,
  path: string,
  readingStatus: ReadingStatus,
  liabilityId: string
  nip: string
}

export enum ReadingStatus {
  PROCESSING = 'PROCESSING',
  READY = 'READY',
  DONE = 'DONE',
  ERROR = 'ERROR'
}
